export const firebaseConfig = {
  apiKey: 'AIzaSyC1MB-j1DBjFaHnGfLJuNST_M6LfiRO3dI',
  authDomain: 'mullerwindsports.firebaseapp.com',
  projectId: 'mullerwindsports',
  storageBucket: 'mullerwindsports.appspot.com',
  messagingSenderId: '20237761026',
  appId: '1:20237761026:web:a30ea37dbc1fc9d0d7451b',
  measurementId: 'G-N30QF5D87C',
};
